#import "./cartFragment.gql"

mutation updateLinesMutation($id: ID!, $lines: [CartLineUpdateInput!]!, $lang: LanguageCode!)
@inContext(language: $lang) {
  cartLinesUpdate(cartId: $id, lines: $lines) {
    cart {
      ...cartFragment
    }
    userErrors {
      field
      message
    }
  }
}
